<template>
  <base-dialog
    :visible="visible"
    :show-close="true"
    width="500px"
    class="dialog-wrap"
    border-radius="none"
    @closed="closed"
  >
    <template v-slot:header>
      <div class="header-wrap">添加邮箱</div>
    </template>
    <div class="email">
      <el-tooltip content="输入多个邮箱用,分隔" placement="bottom">
        <span class="icon-tip pointer">
          <i class="el-icon-info"></i>
        </span>
      </el-tooltip>
      <el-input placeholder="请输入邮箱地址" v-model="emails"></el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <base-button @click="closed">取 消</base-button>
      <base-button type="primary" @click="submit">确 定</base-button>
    </span>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"

export default {
  name: "select-mail-dialog",
  components: {
    BaseDialog,
    BaseButton
  },
  props: {
    visible: Boolean,
    mailList: Array
  },
  data() {
    return {
      emails: ""
    }
  },
  methods: {
    open() {
      this.emails = this.mailList.join(",")
    },
    closed() {
      this.$emit("update:visible", false)
    },
    submit() {
      this.$emit("input", this.emails)
      this.$emit("update:visible", false)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  .email {
    margin-top: 30px;
    display: flex;
    align-items: center;
    flex-direction: row;
    .el-input {
      margin-left: 5px;
    }
  }
}
</style>
